import PropTypes from "prop-types";
import { useMemo } from "react";

// material-ui
import { CssBaseline, StyledEngineProvider } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";

// project-imports
import Palette from "./palette";
import Typography from "./typography";
import CustomShadows from "./shadows";
import componentsOverride from "./overrides";

import { HEADER_HEIGHT } from "config";

// ==============================|| DEFAULT THEME - MAIN  ||============================== //

export default function ThemeCustomization({ children }) {
  const theme = Palette("light");
  const themeTypography = Typography(`Sicpa`);
  const themeCustomShadows = useMemo(() => CustomShadows(theme), [theme]);

  const themeOptions = useMemo(
    () => ({
      breakpoints: {
        values: {
          xs: 0,
          sm: 768,
          md: 1024,
          lg: 1266,
          xl: 1440,
        },
      },
      direction: "ltr",
      mixins: {
        toolbar: {
          minHeight: HEADER_HEIGHT,
          paddingTop: 8,
          paddingBottom: 8,
        },
      },
      // palette: theme.palette,
      palette: {
        ...theme.palette,
        text: {
          // primary: "rgb(244, 3, 20);",
          // secondary: "rgb(244, 3, 20);",
          primary: "rgb(0, 0, 0);",
          secondary: "rgb(0, 0, 0);",
          disabled: "#ff6b6b",
        },
      },

      shape: {
        borderRadius: 8,
      },
      customShadows: themeCustomShadows,
      typography: themeTypography,
    }),
    [theme, themeTypography, themeCustomShadows]
  );

  const themes = createTheme(themeOptions);
  // themes.components = componentsOverride(themes);

  // 🔴 Global red text overrides
  const redTextOverrides = {
    MuiTypography: {
      styleOverrides: {
        root: {
          color: "rgb(0, 0, 0);",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          color: "rgb(0, 0, 0);",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          color: "rgb(0, 0, 0);",
        },
      },
    },
  };

  const redButtonOverrides = {
    MuiButton: {
      styleOverrides: {
        contained: {
          backgroundColor: "rgb(244, 3, 20)",
          color: "#ffffff",
          "&:hover": {
            backgroundColor: "rgb(200, 0, 15)",
          },
          "&.Mui-disabled": {
            backgroundColor: "#ffb3b3",
            color: "#ffffff",
          },
        },
      },
    },
  };

  // const sidebarOverrides = {
  //   MuiListItemButton: {
  //     styleOverrides: {
  //       root: {
  //         color: "#000000", // 🖤 normal text
  //         "& .MuiListItemIcon-root": {
  //           color: "#000000",
  //         },

  //         "&.Mui-selected": {
  //           backgroundColor: "rgba(244, 3, 20, 0.08)",
  //           color: "rgb(0, 0, 0)",

  //           "& .MuiListItemIcon-root": {
  //             color: "rgb(0, 0, 0)",
  //           },
  //         },

  //         "&.Mui-selected:hover": {
  //           backgroundColor: "rgba(244, 3, 20, 0.15)",
  //         },
  //       },
  //     },
  //   },
  //   MuiListItemText: {
  //     styleOverrides: {
  //       primary: {
  //         color: "inherit",
  //         fontWeight: 500,
  //       },
  //     },
  //   },
  // };


  const sidebarOverrides = {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          color: "#000000", // :black_heart: normal text
          borderRadius: "8px", // :white_check_mark: ADDED: rounded border

          "& .MuiListItemIcon-root": {
            color: "#000000",
          },

          "&.Mui-selected": {
            backgroundColor: "rgba(244, 3, 20, 0.08)",
            color: "rgb(0, 0, 0)",

            "& .MuiListItemIcon-root": {
              color: "rgb(0, 0, 0)",
            },
          },

          "&.Mui-selected:hover": {
            backgroundColor: "rgba(244, 3, 20, 0.15)",
          },
        },
      },
    },
  };
  
  themes.components = {
    ...componentsOverride(themes),
    ...redTextOverrides,
    ...redButtonOverrides,
    ...sidebarOverrides,
  };

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themes}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

ThemeCustomization.propTypes = {
  children: PropTypes.node,
};
